import React, { useState, useRef } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";

// import JS files
import MuiModal from "../../shares/MuiModal";
import MuiComboBox from "../../shares/MuiComboBox";
import useFetch from "../../../context/useFetch";
import MuiButton from "../../shares/MuiButton";

// import Others files

const SearchedUserModal = (props) => {
  let windowWidth = window.screen.width;
  const [searchBased, setSearchBased] = useState("customer");
  const [usersList, setUsersList] = useState([]);
  const [searchedText, setSearchedText] = useState("");
  const [selectedUser, setSelectedUser] = useState(undefined);
  const [selectedOption, setSelectedOption] = useState();

  const getListOfUsersApi = useFetch({
    method: "post",
    url: `User_Service/${props.username}/search_user`,
    data: { name: searchedText, type: searchBased },
    argFunc: (res) => {
      setUsersList(res);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const handleSearchedText = (text) => {
    setSearchedText(text);
    if (text.length >= 1) {
      getListOfUsersApi.reFetch();
    }
  };

  const createUserChatApi = useFetch({
    method: "post",
    url: `Chat_Service`,
    data: { user: selectedUser?.user, admin_user: props.username },
    argFunc: (res) => {
      if (res.data !== "chat_exist") {
        props.setChatId(res.id);
        setSelectedUser(undefined);
        setUsersList([]);
        props.apiCall.reFetch();
        props.setOpenModal(false);
      } else {
        toast.error("چت با این کاربر وجود دارد", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-3/5"
        isOverflow={true}
        isNotBackdropClick={true}
      >
        <div>
          <div className="close-modal-icon">
            <CloseIcon
              onClick={() => props.setOpenModal(false)}
              fontSize="large"
              color="secondary"
            />
          </div>

          <div className="flex justify-center border-b border-dashed pb-2 mb-2">
            <p className="font-bold">جستجوی کاربر</p>
          </div>
          <div className="flex justify-center items-center">
            <div className="basis-1/2">
              <FormControl>
                <FormLabel id="demo-controlled-radio-buttons-group">
                  جستجو میان:
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={searchBased}
                  onChange={(e) => {
                    setSearchBased(e.target.value);
                    setUsersList([]);
                  }}
                >
                  <FormControlLabel
                    value="customer"
                    control={<Radio />}
                    label="مشتری"
                  />
                  <FormControlLabel
                    value="provider"
                    control={<Radio />}
                    label="تولیدکننده"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div className="basis-1/2">
              <MuiComboBox
                size="small"
                label="نام"
                labelId="name-search-label"
                id="name-search-select"
                options={usersList}
                placeholder="نام"
                setSelectedUser={setSelectedUser}
                setSearchText={handleSearchedText}
                forUser
                baseWithJustUser
                setSelectedOption={setSelectedOption}
              />

              <div className="text-left mt-4">
                <MuiButton
                  onClick={() => createUserChatApi.reFetch()}
                  variant="contained"
                  color="primary"
                  text="ارسال پیام"
                  size="small"
                  //    icon={<ModeEditIcon />}
                />
              </div>
            </div>
          </div>
        </div>
      </MuiModal>
    </>
  );
};

export default SearchedUserModal;
